;(() => {

    const chatRoomFlags = [];

    CNS.$fns.initChatRoomToolsKeypress = function(chatType) {

        console.log('initChatRoomTools ========'+chatType);
        let shiftKeyPressed = false;
        let enterKeyPressed = false;

        textInput = document.getElementById('chat-room-tols-'+chatType);

        console.log(textInput);

        textInput.addEventListener('keydown', event => {

            const chatType = textInput.dataset.chat;

            if (event.key === 'Shift') {
                shiftKeyPressed = true;
            }
            if (event.key === 'Enter') {
                enterKeyPressed = true;
            }

            if (shiftKeyPressed && enterKeyPressed) {

                console.log("Shift + Enter pressed in input - " + chatType);

                window.livewire.emit('shiftEnterPressed'+chatType);

                shiftKeyPressed = false;
                enterKeyPressed = false;
            }

            if (enterKeyPressed) {
                console.log("Enter pressed in input - " + chatType);

                window.livewire.emit('enterPressed'+chatType);
                enterKeyPressed = false;
            }

        });

        textInput.addEventListener('keyup', event => {
            if (event.key === 'Shift') {
                shiftKeyPressed = false;
            }
            if (event.key === 'Enter') {
                enterKeyPressed = false;
            }
        });
    }

    CNS.$fns.scrollChatRoomToMessage = function(chatRoomId, messageId, scrollToEndIfNotFound) {
        const chatRoom = document.querySelector(`.js-chat-room[data-room-id="${chatRoomId}"]`)
        if (!chatRoom) { return }

        const messagesContainer = chatRoom.querySelector('.chat-room__messages')
        if (!messagesContainer) { return }

        const targetMessage = messagesContainer.querySelector(`.chat-message[data-message-id="${messageId}"]`)

        if (targetMessage) {
            messagesContainer.scrollTo({top: targetMessage.offsetTop, behavior: "smooth"})
        } else if (scrollToEndIfNotFound) {
            CNS.$fns.scrollChatRoomToEnd(chatRoomId)
        }
    }

    CNS.$fns.scrollChatRoomToEnd = function(chatRoomId) {
        const chatRoom = document.querySelector(`.js-chat-room[data-room-id="${chatRoomId}"]`)
        if (!chatRoom) { return }
        const messagesContainer = chatRoom.querySelector('.chat-room__messages')
        if (!messagesContainer) { return }

        const messages = [...messagesContainer.querySelectorAll(`.chat-message`)]
        messagesContainer.scrollTo({top: messages[messages.length - 1].offsetTop, behavior: "smooth"})
    }

    CNS.$fns.initChats = function(roomLiveId) {
        const chatRooms = document.querySelectorAll(`.js-chat-room[data-room-id="${roomLiveId}"]`)

        chatRooms.forEach(room => {

            const messagesContainer = room.querySelector('.chat-room__messages')
            const roomId = room.dataset.roomId
            let canDetectScroll = false
            let hasDown = false
            let hasTop = false
            let lastScroll = 0

            const detectScroll = e => {
                if (!canDetectScroll) { return }

                CNS.$events.chatScrollBottomEvent.roomId = roomId
                CNS.$events.chatScrollTopEvent.roomId = roomId

                const scrollTop = messagesContainer.scrollTop
                const scrollableHeight = messagesContainer.offsetHeight
                const contentHeight = CNS.$fns.getChildrenHeightV2(messagesContainer)

                const scrollDown = lastScroll < scrollTop
                lastScroll = scrollTop

                if (scrollTop <= 0 && !hasTop && !scrollDown) {
                    hasTop = true
                    window.dispatchEvent(CNS.$events.chatScrollTopEvent)
                } else if (scrollTop > 0 && hasTop && scrollDown) {
                    hasTop = false
                }

                if (scrollTop + scrollableHeight + 30 > contentHeight && !hasDown && scrollDown) {
                    hasDown = true
                    window.dispatchEvent(CNS.$events.chatScrollBottomEvent)
                    // console.log('should fire bottom')
                } else if (scrollTop + scrollableHeight - 10 < contentHeight && hasDown && !scrollDown) {
                    hasDown = false
                }
            }

            setTimeout(() => {
                canDetectScroll = true
                messagesContainer.addEventListener('scroll', detectScroll)

                let shouldInit = true;
                chatRoomFlags.forEach(el => {
                    if (el.key == roomLiveId) {
                        if (el.value) {
                            shouldInit = false;
                        }
                    }
                })

                if (shouldInit) {
                    //CNS.$fns.initChatRoomToolsKeypress(roomId);
                    chatRoomFlags.push({key: roomLiveId, value: true})
                }

            }, 100)
        })


    }

    const scrollerCounterHiddenClass = 'chat-scroller__counter_hidden'
    CNS.$fns.setChatScrollerCount = function(chatRoomId, count) {
        const chatRoom = document.querySelector(`.js-chat-room[data-room-id="${chatRoomId}"]`)
        if (!chatRoom) { return }
        const scroller = chatRoom.querySelector('.chat-scroller')
        if (!scroller) { return }
        const scrollerCounter = scroller.querySelector('.chat-scroller__counter')
        if (!scrollerCounter) { return }

        const countToSet = parseInt(count) || 0

        scrollerCounter.innerHTML = countToSet
        if (countToSet == 0) {
            scrollerCounter.classList.add(scrollerCounterHiddenClass)
        } else {
            scrollerCounter.classList.remove(scrollerCounterHiddenClass)
        }
    }

    const scrollerHiddenClass = 'chat-scroller_hidden'
    CNS.$fns.setChatScrollerVisibility = function(chatRoomId, visible) {
        const chatRoom = document.querySelector(`.js-chat-room[data-room-id="${chatRoomId}"]`)
        if (!chatRoom) { return }
        const scroller = chatRoom.querySelector('.chat-scroller')
        if (!scroller) { return }

        if (visible) {
            scroller.classList.remove(scrollerHiddenClass)
        } else {
            scroller.classList.add(scrollerHiddenClass)
        }
    }
})();

;(({ $, $$ }) => {
    const dropHighLightClass = 'chat-room_drop-highlight'
    const chatRooms = $$('.js-chat-room')
    chatRooms.forEach(chatRoom => {
        let designTimer = null

        ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            chatRoom.addEventListener(eventName, event => event.preventDefault(), false)
        })

        ;['dragenter', 'dragover'].forEach(eventName => {
            chatRoom.addEventListener(eventName, () => {
                clearTimeout(designTimer)
                chatRoom.classList.add(dropHighLightClass)
            }, true)
        })

        ;['dragleave', 'drop'].forEach(eventName => {
            chatRoom.addEventListener(eventName, () => {
                designTimer = setTimeout(() => {
                    chatRoom.classList.remove(dropHighLightClass)
                }, 50)
            }, true)
        })

        chatRoom.addEventListener('drop', event => {
            // const dt = event.dataTransfer
            const allowedFormats = [
                'pdf', 'txt', 'png', 'jpg', 'jpeg', 'mpga', 'webp', 'gif', 'bmp', 'doc', 'docx', 'xls', 'xlsx'
            ]

            const dt = new DataTransfer()
            Array.from(event.dataTransfer.files).forEach(file => {
                const fileExtPos = file.name.lastIndexOf('.')
                if (fileExtPos == -1) { return }
                const fileExt = file.name.slice(fileExtPos + 1)
                if (allowedFormats.includes(fileExt)) {
                    dt.items.add(file)
                }
            })

            const input = chatRoom.querySelector('.js-upload-file__input')
            if (input) {
                input.files = dt.files
                input.dispatchEvent(new Event('change'))

            }
        }, false)
    })
})(CNS);

